module.exports = __webpack_public_path__ + "static/media/block-left-bottom.7f78645f.png";